import { render, staticRenderFns } from "./CloneLeadModal.vue?vue&type=template&id=2439b496&"
import script from "./CloneLeadModal.vue?vue&type=script&lang=js&"
export * from "./CloneLeadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports